import _main from './main.js'
const main: any = _main
export default main
